import { createTheme } from '@material-ui/core';

export const theme = createTheme({
  typography: {
    fontFamily: 'Nunito',
    allVariants: {
      color: '#363655',
    },
    body1: {
      fontSize: 16,
    },
  },
  overrides: {
    MuiButton: {
      outlinedPrimary: {
        borderColor: '#232F63',
        color: '#232F63',
        fontWeight: 700,
      },
      containedPrimary: {
        backgroundColor: '#232F63',
        fontWeight: 700,
      },
    },
  },
});
